<div class="dialog-content">{{data?.message}}</div>

<div class="commands-container">
  <lib-button
    [label]="data?.yesButtonLabel ?? 'action.yes' | translate"
    (gnvOnClick)="closeMe(true)"
    [faIconClass]="data?.yesButtonIcon || ''"
  ></lib-button>

<lib-button
    [label]="data?.noButtonLabel ?? 'action.no' | translate"
    [severity]="'secondary'"
    (gnvOnClick)="closeMe()"
    [faIconClass]="data?.noButtonIcon || ''"
  ></lib-button>
</div>
